<!--
 * @Author: Lemon C
 * @Date: 2024-11-11 09:39:57
 * @LastEditTime: 2025-01-06 18:38:23
-->
<template>
    <div class="sup-bady">
        <TypeSwitchComp
            class="top-type-switch"
            :bgClr="type_switch_bg"
            :currId="$globalObj.docs_switch.center"
            :docs_type_switch_click="docs_type_switch_click">
        </TypeSwitchComp>
        <BannerComp class="banner-box"></BannerComp>
        <UpdateComp class="important-update-box" :important_update_list="important_update_list"></UpdateComp>
        <ProductGuideComp class="product-course-box" :product_guide_list="product_guide_list"></ProductGuideComp>
        <DevDemoComp class="dev-demo-box" :dev_demo_list="dev_demo_list"></DevDemoComp>
        <VideoCourseComp class="course-video-box" :course_video_list="course_video_list"></VideoCourseComp>
        <AdvanceCourseComp class="advance-course-box" :advance_course_list="advance_course_list"></AdvanceCourseComp>
        <FAQComp class="faq-msg-box" :faq_msg_list="faq_msg_list"></FAQComp>
    </div>
</template>

// MOD-- JavaScript
<script setup>
import { ref, onMounted, onBeforeUnmount, getCurrentInstance } from 'vue';
import TypeSwitchComp from '@/components/DevCenter/TypeSwitchComp.vue';
import BannerComp from '@/components/DevCenter/BannerComp.vue';
import UpdateComp from '@/components/DevCenter/UpdateComp.vue';
import ProductGuideComp from '@/components/DevCenter/ProductGuideComp.vue';
import DevDemoComp from '@/components/DevCenter/DevDemoComp.vue';
import VideoCourseComp from '@/components/DevCenter/VideoCourseComp.vue';
import AdvanceCourseComp from '@/components/DevCenter/AdvanceCourseComp.vue';
import FAQComp from '@/components/DevCenter/FAQComp.vue';

import { getDocumentTopdocList, getDemoTopList, getDocumentFaqTopList, getDocumentUpgradeTopList } from '@/service/interface';
import { useRouterStore } from '@/stores/router';
import { useMessageStore } from '../../stores/message';

const router_store = useRouterStore();
const message_store = useMessageStore();
const { proxy } = getCurrentInstance();

const service_promise_list = ref([]); // 请求列表
const important_update_list = ref([]); // 重要更新列表
const product_guide_list = ref([]); // 开发教程表
const dev_demo_list = ref([]); // 开发示例DEMO列表
const course_video_list = ref([
    {
        title: '初始化环境设置',
        dis: '手把手教您玩转BLACKHOLE功能，创建BIM应用',
        url: 'https://www.bilibili.com/video/BV1RXrVYuEJ6/?spm_id_from=333.1387.collection.video_card.click&vd_source=39e51a8e350e9f96cc62e0c37b9f538c',
        img: 'video_course_bg_1',
        icon: 'course_video_1',
    },
    {
        title: '创建项目',
        dis: '从搭建到应用，轻松创建自己的BIM+GIS大场景',
        url: 'https://www.bilibili.com/video/BV1RXrVYuEP1/?spm_id_from=333.1387.collection.video_card.click&vd_source=103315b34b84287b2fa4f5c7faa7e761',
        img: 'video_course_bg_2',
        icon: 'course_video_2',
    },
    {
        title: '上传转换',
        dis: '快速掌握常用功能的使用和打开方式',
        url: 'https://www.bilibili.com/video/BV1RXrVYuE7g/?spm_id_from=333.1387.collection.video_card.click&vd_source=103315b34b84287b2fa4f5c7faa7e761',
        img: 'video_course_bg_3',
        icon: 'course_video_3',
    },
]); // 视频教程
const advance_course_list = ref([]); // 进阶教程
const faq_msg_list = ref([]); //faq列表
const type_switch_bg = ref('var(--color-main-dev-center-switch-bg-transparent)'); // 类型选择背景色

onMounted(() => {
    update_data();
    message_store.addMessageHandler(message_store.M_E_NAV_SCROLL, nav_control_scroll);
});

onBeforeUnmount(() => {
    message_store.removeMessageHandler(message_store.M_E_NAV_SCROLL, nav_control_scroll);
});

// MARK Service 更新
const update_data = () => {
    service_faq();
};

// MARK Service  数据请求
const service_faq = () => {
    // 重新生成 promise 列表
    service_promise_list.value = [
        { id: proxy.$globalObj.docs_center_promise.update, promise: getDocumentUpgradeTopList() },
        { id: proxy.$globalObj.docs_center_promise.faq, promise: getDocumentFaqTopList() },
        { id: proxy.$globalObj.docs_center_promise.guide, promise: getDocumentTopdocList({ group: proxy.$globalObj.group.guide }) },
        { id: proxy.$globalObj.docs_center_promise.course, promise: getDocumentTopdocList({ group: proxy.$globalObj.group.course }) },
        { id: proxy.$globalObj.docs_center_promise.demo, promise: getDemoTopList() },
    ];
    proxy.$showLoading();
    let promiseArray = service_promise_list.value.map((e) => e.promise);
    Promise.all(promiseArray).then((response) => {
        proxy.$hideLoading();
        response.forEach((res, index) => {
            let promise_obj = service_promise_list.value[index];
            if (res.isSuccess && promise_obj.id === proxy.$globalObj.docs_center_promise.update) {
                important_update_list.value = [];
                important_update_list.value = res.data.slice(0, 4);
            }
            if (res.isSuccess && promise_obj.id === proxy.$globalObj.docs_center_promise.faq) {
                faq_msg_list.value = [];
                faq_msg_list.value = res.data;
            }
            if (res.isSuccess && promise_obj.id === proxy.$globalObj.docs_center_promise.guide) {
                product_guide_list.value = [];
                product_guide_list.value = res.data;
            }
            if (res.isSuccess && promise_obj.id === proxy.$globalObj.docs_center_promise.course) {
                advance_course_list.value = [];
                advance_course_list.value = res.data;
            }
            if (res.isSuccess && promise_obj.id === proxy.$globalObj.docs_center_promise.demo) {
                dev_demo_list.value = [];
                dev_demo_list.value = res.data;
            }
        });
    });
};
// MARK 类型选择
const docs_type_switch_click = (item) => {
    if (item.route && item.route.length) {
        router_store.navigateTo(item.route);
    }
};
// MARK Evented  滚动监听
const nav_control_scroll = (evented) => {
    type_switch_bg.value = evented.devCenterSwitchBg;
};
</script>

// MOD-- CSS
<style lang="less" scoped>
.sup-bady {
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: column;
    background-color: var(--color-main-light-bg);

    .top-type-switch {
        position: fixed;
        top: var(--nav-height);
        left: 0;
        height: 80px;
        right: 0;
        width: 100%;
        padding: 0 40px;
        box-sizing: border-box;
        z-index: var(--dev-center-type-switch-z-index);
        transition: var(--animation-background-color-style);
        /* 添加过渡效果 */
    }

    .banner-box {
        width: 100%;
        height: 500px;
    }

    .important-update-box {
        width: 100%;
        margin-top: 72px;
        box-sizing: border-box;
    }

    .product-course-box {
        width: 100%;
        margin-top: 100px;
        box-sizing: border-box;
    }

    .dev-demo-box {
        width: 100%;
        margin-top: 100px;
        box-sizing: border-box;
    }

    .course-video-box {
        width: 100%;
        margin-top: 100px;
        box-sizing: border-box;
    }

    .advance-course-box {
        width: 100%;
        margin-top: 100px;
        box-sizing: border-box;
    }

    .faq-msg-box {
        width: 100%;
        margin-top: 100px;
        box-sizing: border-box;
        margin-bottom: 100px;
    }
}
</style>
